// ─────────────────────────────────────────────
//  Staff email address derivation — single source of truth.
//  Format: firstname.lastname@<STAFF_EMAIL_DOMAIN>, lowercased, with spaces,
//  hyphens, apostrophes and parenthetical notes (e.g. "Jose (Andrew)") removed.
//  Used by the seeders and the admin "Fix emails" tool so they never drift.
// ─────────────────────────────────────────────

export const STAFF_EMAIL_DOMAIN = "envisionhealth.com";

// Keep letters only: drops "(Andrew)", spaces, hyphens, apostrophes, dots.
const clean = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/\(.*?\)/g, "")
    .replace(/[^a-z]/g, "");

// Returns "" when neither name part survives cleaning (caller should skip).
export function staffEmail(firstName, lastName, domain = STAFF_EMAIL_DOMAIN) {
  const first = clean(firstName);
  const last = clean(lastName);
  if (!first && !last) return "";
  return `${first}.${last}@${domain}`;
}
